import { useEffect } from "react";
import { useNavigate, useLocation, Navigate, Outlet } from "react-router-dom";
import { Layout, Spin } from "antd";
import LayoutBanner from "./LayoutBanner";
import { useSelector, useDispatch } from "react-redux";
import {
  userSelector,
  fetchUserBytoken,
  clearState,
} from "../../features/authSlice";
import { AUTH_TOKEN_KEY, AUTH_USER_ID_KEY } from "../../constants";

const { Content } = Layout;

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { isFetching, isError, isInitialized, errorMessage } = useSelector(userSelector);

  useEffect(() => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const userId = localStorage.getItem(AUTH_USER_ID_KEY);

    const isValid = (v) => Boolean(v && v !== "null" && v !== "undefined");

    if (isValid(token) && isValid(userId)) {
      dispatch(fetchUserBytoken({ token, id: userId }));
    } else {
      console.warn("⚠️ Token o ID inválidos en MainLayout");
    }
  }, [dispatch]);

  useEffect(() => {
    // Solo cerrar sesión si el error es de autenticación/token
    if (
      isError &&
      errorMessage &&
      /token|autorizad|autentic/i.test(errorMessage)
    ) {
      dispatch(clearState());
      navigate("/login");
    }
    // Si el error no es de autenticación, puedes mostrar un toast o ignorar
  }, [isError, errorMessage, dispatch, navigate]);

  if (!isInitialized) {
    return <Spin size="large" style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }} />;
  }

  // Loader overlay solo para operaciones críticas (auth, inicialización)
  if (isFetching) {
    return (
      <>
        <Layout style={{ minHeight: "100vh" }}>
          <LayoutBanner />
          <Content style={{ padding: "24px", background: "#f5f5f5" }}>
            <Outlet />
          </Content>
        </Layout>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.4)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size="large" />
        </div>
      </>
    );
  }

  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Ruta móvil
  if (location.pathname.includes("mobile")) {
    return <Content><Outlet /></Content>;
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <LayoutBanner />
      <Content style={{ padding: "24px", background: "#f5f5f5" }}>
        <Outlet />
      </Content>
    </Layout>
  );
};

export default MainLayout;